import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=eb4ba5f8&scoped=true&"
import script from "./Patient.vue?vue&type=script&lang=ts&"
export * from "./Patient.vue?vue&type=script&lang=ts&"
import style0 from "./Patient.vue?vue&type=style&index=0&id=eb4ba5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4ba5f8",
  null
  
)

export default component.exports